const mapper_options = {
  endpoint: 'brand_requests/metrics',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand_request: {
        foreignKey: 'brand_request_id',
        localField: 'brand_request'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('brand_request_metrics', mapper_options)
}
